import { IProductCreateUpdate } from '@models/Product.model';
import { IUpdateRawQueryList } from '@models/Update.model';
import {
  CreateUpdatesDialogQuery,
  RelatesToOptions,
} from './CreateUpdatesDialog.query';

interface ICreateUpdatesDialog {
  open: boolean;
  onClose: () => void;
  tab?: 'relationship' | 'affected' | 'details' | 'confirmation';
  relatesToPrev?: RelatesToOptions;
  productPrev?: IProductCreateUpdate;
  edit?: {
    updatePrev: IUpdateRawQueryList;
  };
}

export const CreateUpdatesDialog = (props: ICreateUpdatesDialog) => {
  return <CreateUpdatesDialogQuery {...props} />;
};
